"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartScrollButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var utils_1 = require("../../utils");
var SCROLL_BUTTON_WIDTH = 18;
var SCROLL_BUTTON_HEIGHT = 36;
var SCROLL_BUTTON_POINTER_WIDTH = 4;
var SCROLL_BUTTON_POINTER_HEIGHT = 9;
var SCROLL_BUTTON_POINTER_LEFT_MARGIN = 7;
var SCROLL_BUTTON_POINTER_THICKNESS = 2;
var SCROLL_BUTTON_BORDER_WIDTH = 2;
var SCROLL_BUTTON_MARGIN = 10;
var ARROW_TOP_POINT_Y = SCROLL_BUTTON_HEIGHT / 2 - SCROLL_BUTTON_POINTER_HEIGHT / 2;
var ARROW_BOTTOM_POINT_Y = SCROLL_BUTTON_HEIGHT / 2 + SCROLL_BUTTON_POINTER_HEIGHT / 2;
var ARROW_POINT_1 = SCROLL_BUTTON_POINTER_LEFT_MARGIN + "," + ARROW_TOP_POINT_Y;
var ARROW_POINT_2 = SCROLL_BUTTON_POINTER_LEFT_MARGIN + SCROLL_BUTTON_POINTER_WIDTH + "\n    ," + SCROLL_BUTTON_HEIGHT / 2;
var ARROW_POINT_3 = SCROLL_BUTTON_POINTER_LEFT_MARGIN + "," + ARROW_BOTTOM_POINT_Y;
var ARROW_COORDS = ARROW_POINT_1 + " " + ARROW_POINT_2 + " " + ARROW_POINT_3;
exports.ChartScrollButton = function (_a) {
    var chartWidth = _a.chartWidth, chartHeight = _a.chartHeight, onScroll = _a.onScroll, disabled = _a.disabled, scrollDirection = _a.scrollDirection;
    return (react_1.default.createElement("g", { onClick: disabled ? noop_1.default : onScroll, transform: scrollDirection === 'left'
            ? "translate(" + SCROLL_BUTTON_MARGIN + ", " + (chartHeight / 2 - SCROLL_BUTTON_HEIGHT / 2) + ")"
            : "translate(" + (chartWidth - SCROLL_BUTTON_MARGIN - SCROLL_BUTTON_WIDTH) + ", " + (chartHeight / 2 - SCROLL_BUTTON_HEIGHT / 2) + ")", style: { cursor: disabled ? 'default' : 'pointer' }, opacity: disabled ? 0.3 : 1 },
        react_1.default.createElement(StyledScrollButton, { x: "0", y: "0", width: SCROLL_BUTTON_WIDTH, height: SCROLL_BUTTON_HEIGHT, fill: "white", disabled: disabled }),
        react_1.default.createElement(StyledArrow, { points: ARROW_COORDS, transform: scrollDirection === 'left'
                ? "scale(-1,-1) translate(-" + SCROLL_BUTTON_WIDTH + ", -" + SCROLL_BUTTON_HEIGHT + ")"
                : '' })));
};
var StyledScrollButton = styled_components_1.default(function (_a) {
    var disabled = _a.disabled, rest = tslib_1.__rest(_a, ["disabled"]);
    return (react_1.default.createElement("rect", tslib_1.__assign({}, rest)));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  stroke: ", ";\n  stroke-width: ", ";\n  :hover {\n    fill: ", ";\n  }\n"], ["\n  stroke: ", ";\n  stroke-width: ", ";\n  :hover {\n    fill: ", ";\n  }\n"])), utils_1.theme.colors.aqua[400], SCROLL_BUTTON_BORDER_WIDTH, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'white' : '#eaeaea');
});
var StyledArrow = styled_components_1.default.polyline(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  stroke: black;\n  stroke-width: ", ";\n  fill: none;\n"], ["\n  stroke: black;\n  stroke-width: ", ";\n  fill: none;\n"])), SCROLL_BUTTON_POINTER_THICKNESS);
var templateObject_1, templateObject_2;
